import React from "react";
import ViewExtensionTrackerTimeline from "../../cheque-management/deposites/components/ViewExtensionTrackerTimeline";
import { Tooltip } from "@mui/material";
import InfoIconSolid from "assets/img/svg/svgComponents/InfoIconSolid";

const STATUS_CONFIG = {
  APPROVED: { text: "Deposited", bg: "#E4F6EA", color: "#299F59" },
  REJECTED: { text: "Rejected", bg: "#FFEBEB", color: "#BD3131" },
  PENDING: { text: "Pending", bg: "#FCEFD3", color: "#C47F00" },
  DATE_EXTENDED: { text: "Date Extended", bg: "#FCEFD3", color: "#C47F00" },
  DATE_EXTENSION_REQUESTED: { text: "Extension is progress", bg: "#FCEFD3", color: "#C47F00" },
  IN_PROGRESS: { text: "In Progress", bg: "#FCEFD3", color: "#C47F00" },
  ACTION_NEEDED: { text: "Action Needed", bg: "#FFE9E9", color: "#D64545" },
  SENT_CORRECTION: { text: "Sent Correction", bg: "#FFE9E9", color: "#D64545" },
  DEPOSITED: { text: "Deposited", bg: "#E4F6EA", color: "#299F59" },
  NOT_DEPOSITED: { text: "Not Deposited", bg: "#F5F5F5", color: "#757575" },
  CANCELLED: { text: "Cancelled", bg: "#FFEBEB", color: "#BD3131" },
  BOUNCED: { text: "Bounced", bg: "#FFEBEB", color: "#BD3131" },
  CANC_FAILED: { text: "Cancel failed", bg: "#FFEBEB", color: "#BD3131" },

};

const not_slitted_statuses = ["NOT_DEPOSITED", 'DATE_EXTENDED', 'IN_PROGRESS', "DATE_EXTENSION_REQUESTED", "SENT_CORRECTION",'CANC_FAILED'];

const getStatusConfig = (status = "") => {
  // Handle L1_, L2_, L3_ prefixed statuses
  if (!status) {
    return { text: "Not Available", bg: "#F5F5F5", color: "#757575" };
  }
  const normalizedStatus = status.includes("_") && !not_slitted_statuses.includes(status)
    ? status.split("_").slice(1).join("_") // L2_APPROVED → APPROVED
    : status;

  const level = status.startsWith("L") ? status.split("_")[0] : null;
  console.log("status",status,level,normalizedStatus);

  const base = STATUS_CONFIG[normalizedStatus] || {
    text: "Not Available",
    bg: "#F5F5F5",
    color: "#757575",
  };

  return {
    ...base,
    text: level ?((base.text=='Deposited') || base.text=='Rejected')?base?.text: `${level} ${base.text}` : base.text,
  };
};

const ReceiptStatusChip = ({ status, row,fetchTrackerTimeLine, editHandler,paymentType, remarks, approvalStatus}) => {
  const styles = getStatusConfig(status);
  const resubmitHandler = () => {
    editHandler(row);
    console.log("Resubmit action triggered for row:", row);
  }

  return (
    <span
      style={{
        backgroundColor: styles.bg,
        color: styles.color,
        fontSize: "12px",
        padding: "4px 10px",
        borderRadius: "16px",
        fontWeight: 500,
        display: "inline-block",
        whiteSpace: "nowrap",
        minWidth: "110px",
        textAlign: "center",
      }}
    >
      {
      status&&(status?.toLowerCase().includes("correction")||
      status?.toLowerCase().includes("rejected") || 
      status?.toLowerCase().includes("extended") ||
      status?.toLowerCase().includes("extension")||
      status?.toLowerCase().includes("extension_requested")
    )
       ?
      <span>
        
      {styles?.text}
      {console.log('paymentStatus',paymentType,approvalStatus)}
      {paymentType!='cash' ?
      <ViewExtensionTrackerTimeline 
      text={styles?.text} 
      row={row} 
      resubmitHandler={resubmitHandler}
      fetchTrackerTimeLine={fetchTrackerTimeLine}
      color={styles?.color}
      />:
            <Tooltip title={remarks || "-"}> <span className='ml-2'><InfoIconSolid color={styles?.color} />
            </span>
            </Tooltip>
      }  
      </span>
      : styles.text
    }
    </span>
  );
};

export default ReceiptStatusChip;
